import styles from './style.module.scss'

export const stepsData = [
	['У вас есть клиент, которому нужны деньги', styles.stepOne],
	['Вы отправляете клиенту свою реферальную ссылку на нашу форму заявки', styles.stepTwo],
	[
		'Клиент решает свой вопрос и получает деньги, а вы зарабатываете вознаграждение',
		styles.stepTree,
	],
]
